import { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { selectIsLoading } from "redux-toolkit/predictions/selectors";
import { updatePredictionAsync } from "redux-toolkit/predictions/actions";

const useUpdatePrediction = () => {
  const dispatch = useDispatch();
  const isLoading = useSelector(selectIsLoading);

  const updatePrediction = useCallback(
    (id, data) => {
      dispatch(updatePredictionAsync({ id, data }));
    },
    [dispatch],
  );

  return {
    isLoading,
    updatePrediction,
  };
};

export default useUpdatePrediction;
